export default __webpack_public_path__ + "static/media/Trade_pink.84ef49eb.svg";